<tcm-main-search-layout [useAdvancedSearch]="false"
                        [useExport]="false"
                        [useGlobalSearch]="false"
                        [isLoading]="isLoading"
                        [(searchTerm)]="searchTerm"
                        titleKey="Screens.Patients.Details.Equipment.Title">
  
  <ng-container commands>
   
    <button class="btn btn-default me-4"
            (click)="back()">
      {{'Common.SearchActionsAndDetailsActions.Cancel' | translate}}
    </button>
    <button actionButton *ngIf="viewModel && viewModel.records && viewModel.records.length > 0 && specialActionPermissions.allowToUpdateLatestEquipmentOnPatient.canExecute"
            class="btn btn-complete"
            (click)="updateLatest()"
            [disabled]="!isAnyEquipmentSelected">
      {{'Screens.Patients.InfoWidget.MakeLatest' | translate}}
    </button>
  </ng-container>
  <ng-container *ngIf="viewModel" after-export-area>
    
  </ng-container>
  <ng-container results-area *ngIf="viewModel">
    <div class="tcm-details-panel">
      <div class="row">

        <div class="col-md-4 section-header fw-bold">
          {{'Screens.Patients.InfoWidget.PatientEquipment' | translate}}
        </div>
        <div class="col-md-4">
          <span class="fw-bold">  {{'Screens.Patients.InfoWidget.Right' | translate}}:</span>   {{ viewModel.rightEquipment }}
        </div>
        <div class="col-md-4">
          <span class="fw-bold"> {{'Screens.Patients.InfoWidget.Left' | translate}}:</span>   {{ viewModel.leftEquipment }}
        </div>
      </div>
    </div>
    <search-results [search]="searchInstance">
      <table class="search-table">
        <thead>
          <tr>
            <th *ngIf="specialActionPermissions.allowToUpdateLatestEquipmentOnPatient.canExecute">
            </th>
            <th table-header key="ProductGroupName"
                [label]="'Common.SearchColumnsAndDetailsFields.ProductGroup' | translate"
                [sortModel]="requestModel.sorting" (sort)="onSortChanged()"></th>
            <th table-header key="ProductStyleName"
                [label]="'Common.SearchColumnsAndDetailsFields.Product' | translate"
                [sortModel]="requestModel.sorting" (sort)="onSortChanged()"></th>
            <th table-header key="ProductOrientation"
                [label]="'Common.SearchColumnsAndDetailsFields.ProductOrientation' | translate"></th>
            <th table-header key="SerialNumber"
                [label]="'Common.SearchColumnsAndDetailsFields.SerialNumber' | translate"
                [sortModel]="requestModel.sorting" (sort)="onSortChanged()"></th>
            <th table-header key="DateSoldLoaned"
                [label]="'Screens.Patients.Details.Equipment.Columns.DateSoldOrLoaned' | translate"
                [sortModel]="requestModel.sorting" (sort)="onSortChanged()"></th>
            <th table-header key="ExpirationDate"
                [label]="'Screens.Patients.Details.Equipment.Columns.ExpirationDate' | translate"
                [sortModel]="requestModel.sorting" (sort)="onSortChanged()"></th>
            <th table-header key="Status" [label]="'Common.SearchColumnsAndDetailsFields.Status' | translate"
                [sortModel]="requestModel.sorting" (sort)="onSortChanged()"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let equipmentItem of viewModel.records; let index=index; let odd=odd; let even=even;"
              [ngClass]="{odd: odd, even:even}">
            <td *ngIf="specialActionPermissions.allowToUpdateLatestEquipmentOnPatient.canExecute">
              <input type="checkbox" (change)="checkIfAllSelected($event,equipmentItem);" class="checkbox-format">

            </td>
            <td>{{equipmentItem.productGroupName}}</td>
            <td>{{equipmentItem.productStyleName}}</td>
            <td>{{equipmentItem.productOrientation}}</td>
            <td>{{equipmentItem.serialNumber}}</td>
            <td>{{equipmentItem.dateSoldLoaned | wafShortDate}}</td>
            <td>{{equipmentItem.expirationDate | wafShortDate}}</td>
            <td>{{serializedItemStatusTranslations[equipmentItem.status]}}</td>
          </tr>
        </tbody>
      </table>
      <tableMultiSelectrecord [search]="searchInstance"></tableMultiSelectrecord>
      <search-paging *ngIf="requestModel && viewModel" [search]="searchInstance"></search-paging>
    </search-results>

  </ng-container>

  <ng-container *ngIf="viewModel" right-sidebar-area></ng-container>
</tcm-main-search-layout>
